(function(){
  document.addEventListener('DOMContentLoaded', () => {
    const menuBtn = document.querySelector('.navbar-button');
    const navbarItems = document.querySelectorAll('.navbar-item');
    const menu = document.querySelector('.menu-header ul');
    const subMenu = document.querySelectorAll('.menu-header ul.sub-menu');
    const back = document.querySelectorAll('.sub-menu > li:first-child');

    if (!menuBtn) {
      return;
    }

    menuBtn.addEventListener('click', () => {
      navbarItems.forEach(el => el.classList.toggle('active'));      
      menu.classList.remove('active');      
      subMenu.forEach(el => el.classList.remove('active'));
    });

    let submenuLinks = document.querySelectorAll('.menu-header li.menu-item-has-children');
    
    submenuLinks.forEach(el => el.addEventListener('click', (e) => {      
      e.stopPropagation();
      const menuChild = el.querySelector(':scope > ul.sub-menu');
      if (menuChild) menuChild.classList.add('active');
      menu.classList.add('active');
      el.classList.add('active');
    }));

    back.forEach(el => el.addEventListener('click', (e) => {
      e.stopPropagation();
      el.classList.remove('active');
      subMenu.forEach(el => el.classList.remove('active'));
      menu.classList.remove('active');
    }));

    const header = document.querySelector('header');
    const anchor = document.createElement('div'); 
    anchor.style.height = '1px';
    anchor.style.position = 'absolute';
    anchor.style.top = '0';
    document.body.prepend(anchor);

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (!entry.isIntersecting) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        },
        { threshold: 0.1 }
    );

    observer.observe(anchor);
  });
  
})();